export default {
  "welcome": "Welcome back",
  "subtitle": "Sign in to your QuickBox Pro dashboard",
  "signIn": "Sign in",
  "chooseMethod": "Choose an authentication method.",
  "password": "Password",
  "passkey": "Passkey",
  "username": "Username or Email",
  "forgot": "Forgot password?",
  "remember_one": "Remember me for {{count}} day",
  "remember_other": "Remember me for {{count}} days",
  "signingIn": "Signing in…",
  "needAccount": "Need an account?",
  "createAccount": "Create account",
  "useRegisteredPasskey": "Use a registered passkey on this device.",
  "usePasskey": "Use Passkey",
  "passkeyPrompt": "Your browser will prompt for a platform or synced passkey.",
  "passkeyUnavailable": "Passkeys are not available in this browser.",
  "passkeyFailed": "Passkey login failed.",
  "twoFactor": "Two-factor verification",
  "recovery": "Recovery code",
  "verification": "Verification code",
  "useRecovery": "Use recovery code instead",
  "verify": "Verify",
  "enterCode": "Enter the code from your authenticator app or a recovery code.",
  "activated": "Your account has been activated. You can now sign in.",
  "activationFailed": "Account activation failed.",
  "invalidActivation": "Invalid activation link.",
  "passwordReset": "Your password has been reset. Sign in with your new password.",
  "maintenance": "System is in maintenance mode.",
  "finishVerification": "Enter your verification code to finish signing in.",
  "loginFailed": "Unable to sign in.",
  "updated": "Dashboard was recently updated. Reloading with the latest version...",
  "network": "Network error. Please try again.",
  "passwordFirst": "Please sign in with your password first.",
  "verificationFailed": "Verification failed.",
  "suspended": "Your account has been suspended. Contact your administrator.",
  "registerTitle": "Create your account",
  "registerSubtitle": "Join the QuickBox Pro dashboard",
  "registerHeading": "Register",
  "registerDescription": "Basic details for your workspace.",
  "registrationDisabled": "User registration is disabled by the administrator.",
  "backToLogin": "Back to login",
  "checkEmail": "Check your email",
  "activationEmail": "We've sent a verification link to {{email}}. Click the link to activate your account.",
  "activationExpiry": "The link expires in 24 hours. Check your spam folder if you don't see it.",
  "awaitingApproval": "Awaiting approval",
  "approvalDescription": "Your account has been created and is pending administrator approval. You'll be able to log in once approved.",
  "goToLogin": "Go to login",
  "registerUsername": "Username",
  "email": "Email",
  "creating": "Creating…",
  "hasAccount": "Already have an account?",
  "registerFailed": "Unable to register.",
  "createdEmail": "Account created! Check your email to activate.",
  "createdAdmin": "Account created! Awaiting admin approval.",
  "createdWelcome": "Account created. Welcome to QuickBox Pro.",
  "registrationUnavailable": "Registration is not available.",
  "forgotTitle": "Reset your password",
  "forgotSubtitle": "We'll send you a link to get back in",
  "forgotHeading": "Forgot password",
  "forgotDescription": "Enter your account email address.",
  "forgotSuccess": "If an account with that email exists, we've sent a password reset link. Check your inbox and spam folder.",
  "forgotExpiry": "The link expires in 1 hour.",
  "emailAddress": "Email address",
  "sending": "Sending…",
  "sendReset": "Send reset link",
  "rememberPassword": "Remember your password?",
  "requestFailed": "Something went wrong. Please try again.",
  "invalidLink": "Invalid link",
  "invalidLinkSubtitle": "This reset link is missing or malformed",
  "missingToken": "No reset token found. Please request a new password reset link.",
  "requestNewLink": "Request new link",
  "resetTitle": "Set a new password",
  "resetSubtitle": "Choose a secure password for your account",
  "resetHeading": "Reset password",
  "resetDescription": "Enter your new password below.",
  "newPassword": "New password",
  "confirmPassword": "Confirm password",
  "passwordMismatch": "Passwords do not match.",
  "resetting": "Resetting…",
  "resetFailed": "Unable to reset password. The link may have expired.",
  "maintenanceDefault": "We're performing scheduled maintenance. Please check back soon.",
  "maintenanceTitle": "Maintenance in progress",
  "maintenanceSubtitle": "The dashboard is temporarily unavailable.",
  "maintenanceHeading": "We'll be back shortly",
  "maintenanceThanks": "Thank you for your patience.",
  "notFoundTitle": "Page not found",
  "notFoundDescription": "The path {{path}} doesn't match any page in the dashboard.",
  "backToDashboard": "Back to Dashboard",
  "linkDashboard": "Dashboard",
  "linkProfile": "Profile",
  "linkSettings": "Settings",
  "linkChangelog": "Changelog",
  "usernameMin": "Username must be at least {{count}} characters",
  "usernameMax": "Username must be at most {{count}} characters",
  "usernameLowercase": "Username must be lowercase",
  "usernameStart": "Username must start with a lowercase letter",
  "usernamePattern": "Username does not match the required pattern",
  "usernameNamedPattern": "Username does not match the required pattern ({{pattern}})",
  "passwordMin": "Password must be at least {{count}} characters",
  "passwordMax": "Password must be at most {{count}} characters",
  "passwordCharacters": "Password cannot contain backticks, tildes, or quotes",
  "resetUserMissing": "User not found",
  "resetAdminForbidden": "Cannot reset super admin password",
  "resetSyncFailed": "System password updated but database sync failed. Please contact support.",
  "resetSystemFailed": "Failed to reset system password: {{details}}",
  "resetInvalid": "Invalid or expired reset link",
  "resetUsed": "This reset link has already been used",
  "resetExpired": "This reset link has expired. Please request a new one.",
  "validEmailRequired": "A valid email address is required.",
  "tooManyAttempts": "Too many attempts. Please try again later.",
  "tokenPasswordRequired": "Token and password are required.",
  "invalidRegistration": "Invalid registration payload",
  "tooManyRegistrations": "Too many registrations. Try again shortly.",
  "usernameExists": "Username already exists.",
  "emailExists": "Email already in use.",
  "accountExists": "Username or email already exists.",
  "passwordRange": "Password must be between {{min}} and {{max}} characters",
  "usernameNotAllowed": "This username is not allowed",
  "unknownError": "Unknown error",
  "usernameMin_one": "Username must be at least {{count}} character",
  "usernameMin_other": "Username must be at least {{count}} characters",
  "usernameMax_one": "Username must be at most {{count}} character",
  "usernameMax_other": "Username must be at most {{count}} characters",
  "passwordMin_one": "Password must be at least {{count}} character",
  "passwordMin_other": "Password must be at least {{count}} characters",
  "passwordMax_one": "Password must be at most {{count}} character",
  "passwordMax_other": "Password must be at most {{count}} characters"
} as const;
